<template>
    <div class="specialProjectSettingDialog">
        <el-dialog @close="cancel" :title="'项目设置'" :visible.sync="dialogVisible" width="908px"  :close-on-click-modal="false">
            <div class="filters">
                <div class="add flexstart">
                    <el-button type="primary" @click="handleAdd">新增配置</el-button>
                </div>
                <div class="search"></div>
            </div>
            <div class="result-list btn-operate-list">
                <el-table :data="tableData" style="width: 100%" ref="multipleTable">
                    <el-table-column type="index" width="50"></el-table-column>
                    <el-table-column prop="name" label="行首名称" class-name="title"></el-table-column>
                    <el-table-column prop="contentname" label="标题内容" min-width="300px" class-name="title">
                        <template slot-scope="scope">
                            <div class="text-ellipse">{{scope.row.contentname}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="datetime" label="排序" class-name="tc" label-class-name="tc" width="100px">
                        <template slot-scope="scope">
                            <div class="upordown">
                                <div class="icon_bb_arrow" :class="[scope.$index==0?'prohibit':'']">
                                    <i @click.stop="handleUp(scope.row, scope.$index)" class="icon icon_bb_arrow_up"></i>
                                </div>
                                <div class="icon_bb_arrow" :class="[scope.$index==(tableData.length-1)?'prohibit':'']">
                                    <i @click.stop="handleDown(scope.row, scope.$index)" class="icon icon_bb_arrow_down"></i>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="120px" label-class-name="tr">
                        <template slot-scope="scope">
                            <div class="tr">
                                <span class="separator-btn">
                                    <el-button @click.stop="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                                </span>
                                <span class="separator-btn">
                                    <el-button @click.stop="handleDel(scope.row)" type="text" size="small">删除</el-button>
                                </span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination background @current-change="_getList" :current-page.sync="page.page"
                               :page-size="page.pageSize"
                               :pager-count="11" layout="prev, pager, next" :total="total">
                </el-pagination>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {getAllQuestionbankindexsectiontask, uploadQuestionbanktopicsectionindex, deleteQuestionbanktopicsectiontask} from 'api/questionApi'
import {mapGetters, mapActions} from 'vuex'

export default {
    name: 'specialProjectSettingDialog',
    data() {
        return {
            dialogVisible: false,
            tableData: [],
            param: {
                examcode: this.$route.query.examcode,
                sectionid: ''
            },
            page: {
                page: 1,
                pageSize: 10,
                pageCount: 0
            },
            total: 0,
            selectRow: {}
        }
    },
    mounted() {
    },
    methods: {
        handleAdd() {
            this.selectRow = {
                sectionid: this.param.sectionid,
                innerid: '',
                name: '',
                linkurl: ''
            }
            this.$emit('openGroupDialog', this.selectRow)
        },
        handleEdit(row) {
            this.selectRow = {
                sectionid: this.param.sectionid,
                innerid: row.innerid,
                name: row.name,
                linkurl: row.linkurl
            }
            this.$emit('openGroupDialog', this.selectRow)
        },
        handleDel(row) {
            this.$confirm('确认删除', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                this._del(row.innerid)
            })
        },
        handleQuery() {
            this.page.page = 1
            this._getList()
        },
        handleUp(obj, index) {
            let item = {
                catetype: -1, // 上移-1 下移1
                examcode: this.param.examcode,
                innerid: this.param.sectionid, // 组别id ,
                taskinnerid: obj.innerid, // 项目id
                type: 2 // 类型 1 组别 2项目
            }
            this._editIndex(item, index)
        },
        handleDown(obj, index) {
            let item = {
                catetype: 1, // 上移-1 下移1
                examcode: this.param.examcode,
                innerid: this.param.sectionid, // 组别id ,
                taskinnerid: obj.innerid, // 项目id
                type: 2 // 类型 1 组别 2项目
            }
            this._editIndex(item, index)
        },
        cancel() {
            this.dialogVisible = false
        },
        openDialog(sectionid) {
            this.param.sectionid = sectionid
            this.tableData = []
            this._getList()
            this.dialogVisible = true
        },
        getList() {
            this.page.page = 1
            this._getList()
        },
        _del(param) {
            this.setLoading(true)
            deleteQuestionbanktopicsectiontask({
                data: {innerid: param},
                success: () => {
                    this.$message.success('删除成功')
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _editIndex(param, index) {
            this.setLoading(true)
            uploadQuestionbanktopicsectionindex({
                data: param,
                success: () => {
                    this.$message.success(`${param.catetype==1? '下移': '上移'}成功`)
                    let obj = this.tableData[index]
                    this.tableData.splice(index, 1)
                    if (param.catetype==1) {
                        this.tableData.splice(index + 1, 0, obj)
                    } else {
                        this.tableData.splice(index - 1, 0, obj)
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getAllQuestionbankindexsectiontask({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .specialProjectSettingDialog {
        .separator-btn{
            .el-button{
                min-width: auto !important;
                margin-bottom: 0;
            }
        }
        .separator-btn+.separator-btn{
            &:before{
                content: '|';
                margin: 0 6px;
                color: #409EFF;
            }
        }
    }
</style>
